export { default as createStyles } from '@material-ui/core/styles/createStyles';
export { default as withStyles } from '@hedtech/react-design-system/core/es/styles/withStyles';
